exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-8c50c2e6]{height:calc(2.1rem + 2px);width:auto}", ""]);

// exports
